<template>
  <!--<div>-->
    <div style="height: 100%;" >
      <header>
        <div class="headerDiv" v-on:click="backHistory"  @click="">
          <img src="@/assets/img/back.png" alt="">
          <p style="color: #FFFFFF">我的订单</p>
        </div>
      </header>
      <div class="shopList">
        <van-tabs v-model="active"  @click="selectOrderList">
          <van-tab title="全部">
            <van-empty v-if="list==null||list.length==0" description="暂无订单" />
            <div class="shopListDiv" v-for="(item,index) in list" :key="index">

              <div style="padding:12px 0;"  v-for="(pros,value) in item.item" :key="value" >
                <div style="display: flex;justify-content: space-between">
                  <p class="shopIcon" >
                  <span><img :src="pros.merchant_logo" style="width: 20px" alt=""></span>
                <span class="shopIconSpan">{{pros.merchant_title}}</span>
                <span class="shopIconSpan"><van-icon name="arrow"/></span>
                  </p>
                <p>

                  <span class="status" v-if="item.pintuan_status==201">已拼单,还差一人</span>
                  <span class="status" v-if="item.pintuan_status==202">拼单成功</span>
                  <span class="status" v-if="item.pay_status==0">未支付</span>
                  <span class="status" v-if="item.pay_status==1">已支付</span>
                  <span class="status" v-if="item.pay_status==2">已退款</span>
                  <span class="status" v-if="item.pay_status==3">部分退款</span>
                </p>
                </div>
                <div class="shopListDetails" v-for="(good,key) in pros.goods" @click="toallOrderDetail(item)">
                <div class="shopListDetailsImg">
                  <img :src="good.image" alt="">
                </div>
                <div class="shopRoduct">
                  <div class="shopListStatus">
                    <p >
                      <span style="font-size: 15px">{{good.title}}</span>
                    </p>
                  </div>
                  <div class="shopPrice">
                    <p class="shopRoductM" style="color: #ff2500"><span>￥{{good.total_price-item.preferential_price}}</span></p>
                    <p class="shopRoductM"><span></span><span style="color:#898888;font-size: 14px">共{{good.buy_number}}件</span></p>
                  </div>
                 </div>
                </div>

                <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0;margin-top: 10px"></van-divider>
              </div>
              <p class="delOrder" v-if="item.pay_status==0"><span class="delOrderSpan" @click="deleteOrder(item.id)">取消订单</span><span class="delOrderStyle" @click="toOrderPay(item)">去支付</span></p>
              <p class="delOrder" v-if="item.pay_status==1"><span class="delOrderStyle" >再次购买</span></p>
            </div>

          </van-tab>
          <van-tab title="待支付">
            <van-empty v-if="list==null||list.length==0" description="暂无订单" />
            <div class="shopListDiv" v-for="(item,index) in list" :key="index">

              <div style="padding:12px 0;"  v-for="(pros,value) in item.item" :key="value" >
                <div style="display: flex;justify-content: space-between">
                  <p class="shopIcon" >
                    <span><img :src="pros.merchant_logo" style="width: 20px" alt=""></span>
                    <span class="shopIconSpan">{{pros.merchant_title}}</span>
                    <span class="shopIconSpan"><van-icon name="arrow"/></span>

                    <!--</span>-->
                  </p>
                  <p>
                    <span class="status" v-if="item.pay_status==0">未支付</span>
                    <span class="status" v-if="item.pay_status==1">已支付</span>
                    <!--<span class="status" v-if="pros.status==1">已发货</span>-->
                    <!--<span class="status" v-if="pros.status==4">已收货</span>-->
                    <!--<span class="status" v-if="pros.status==5">用户拒收</span>-->
                  </p>
                </div>
                <div class="shopListDetails" v-for="(good,key) in pros.goods" @click="toallOrderDetail(item)">
                  <div class="shopListDetailsImg">
                    <img :src="good.image" alt="">
                  </div>
                  <div class="shopRoduct">
                    <div class="shopListStatus">
                      <p >
                        <span style="font-size: 15px">{{good.title}}</span>
                      </p>
                    </div>
                    <div class="shopPrice">
                      <p class="shopRoductM" style="color: #ff2500"><span>￥{{good.total_price-item.preferential_price}}</span></p>
                      <p class="shopRoductM"><span></span><span style="color:#898888;font-size: 14px">共{{good.buy_number}}件</span></p>
                    </div>
                  </div>
                </div>

                <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0;margin-top: 10px"></van-divider>
              </div>
              <p class="delOrder"><span class="delOrderSpan" @click="deleteOrder(item.id)">取消订单</span><span class="delOrderStyle" @click="toOrderPay(item)">去支付</span></p>
              <!--<p class="delOrder" v-if="item.pay_status==1"><span class="delOrderStyle" @click="deleteOrder(pros.id)">再次购买</span></p>-->
            </div>
          </van-tab>
          <van-tab title="待发货">
            <van-empty v-if="list==null||list.length==0" description="暂无订单" />
            <div class="shopListDiv" v-for="(item,index) in list" :key="index">
              <div style="padding:12px 0;"  v-for="(pros,value) in item.item" :key="value" >
                <div style="display: flex;justify-content: space-between">
                  <p class="shopIcon" >
                    <span><img :src="pros.merchant_logo" style="width: 20px" alt=""></span>
                    <span class="shopIconSpan">{{pros.merchant_title}}</span>
                    <span class="shopIconSpan"><van-icon name="arrow"/></span>
                  </p>
                  <p>
                    <span class="status" v-if="item.pay_status==0">未支付</span>
                    <span class="status" v-if="item.pay_status==1">已支付</span>
                  </p>
                </div>
                <div class="shopListDetails" v-for="(good,key) in pros.goods" @click="toallOrderDetail(item)">
                  <div class="shopListDetailsImg">
                    <img :src="good.image" alt="">
                  </div>
                  <div class="shopRoduct">
                    <div class="shopListStatus">
                      <p >
                        <span style="font-size: 15px">{{good.title}}</span>
                      </p>
                    </div>
                    <div class="shopPrice">
                      <p class="shopRoductM" style="color: #ff2500"><span>￥{{good.total_price}}</span></p>
                      <p class="shopRoductM"><span></span><span style="color:#898888;font-size: 14px">共{{good.buy_number}}件</span></p>
                    </div>
                  </div>
                </div>
                <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0;margin-top: 10px"></van-divider>
              </div>
              <p class="delOrder"><span class="delOrderStyle" >再次购买</span></p>
            </div>
          </van-tab>
          <van-tab title="待收货">
            <!--<van-empty v-if="list==null||list.length==0" description="暂无订单" />-->
            <div class="shopListDiv" v-for="(item,index) in list" :key="index">
              <div style="padding:12px 0;"  v-for="(pros,value) in item.item" :key="value" >
                <div style="display: flex;justify-content: space-between">
                  <p class="shopIcon" >
                    <span><img :src="pros.merchant_logo" style="width: 20px" alt=""></span>
                    <span class="shopIconSpan">{{pros.merchant_title}}</span>
                    <span class="shopIconSpan"><van-icon name="arrow"/></span>
                  </p>
                  <p>
                    <span class="status" v-if="item.pay_status==0">未支付</span>
                    <span class="status" v-if="item.pay_status==1">已支付</span>
                  </p>
                </div>
                <div class="shopListDetails" v-for="(good,key) in pros.goods" @click="toallOrderDetail(item)">
                  <div class="shopListDetailsImg">
                    <img :src="good.image" alt="">
                  </div>
                  <div class="shopRoduct">
                    <div class="shopListStatus">
                      <p >
                        <span style="font-size: 15px">{{good.title}}</span>
                      </p>
                    </div>
                    <div class="shopPrice">
                      <p class="shopRoductM" style="color: #ff2500"><span>￥{{good.total_price}}</span></p>
                      <p class="shopRoductM"><span></span><span style="color:#898888;font-size: 14px">共{{good.buy_number}}件</span></p>
                    </div>
                  </div>
                </div>
                <van-divider dashed size="20px"  hairline="false" style="border-width: 2px 0 0;margin-top: 10px"></van-divider>
              </div>
              <p class="delOrder" v-if="item.pay_status==0"><span class="delOrderSpan" @click="deleteOrder(item.id)">取消订单</span><span class="delOrderStyle" @click="toOrderPay(item)">去支付</span></p>
              <p class="delOrder" v-if="item.pay_status==1"><span class="delOrderStyle" >再次购买</span></p>
            </div>
          </van-tab>
          <van-tab title="待评价"><van-empty v-if="list==null||list.length==0" description="暂无订单" /></van-tab>
        </van-tabs>
        <!--<van-checkbox-group   >-->


      </div>
    </div>

  <!--</div>-->
</template>

<script>
  export default {
    data () {
      return {
        all:false,
        active:0,
        list:[],
        totalPrice:0
      }
    },
    methods: {
      backHistory(){
        this.$router.push("/myShop")
      },
      toallOrderDetail(item){
//        console.log(id)
        console.log(item)
        localStorage.setItem("orderImg",item.pintuan_qrcode)
        this.$router.push({
          path:"/allOrderDetail",
          query:{
            id:item.id,
            orderTid:item.pintuan_tid//详情里面生成二维码
          }
        })
      },
      onSwipeLeft(){
        this.$router.push("/myShop")
      },
      toOrderPay(item){
        let price=0
        let arr=0
        let goodsid=""
        item.item.forEach(res=>{
          res.goods.forEach(total=>{
            console.log(total)
            price+=Number(total.total_price)
            arr+=Number(total.buy_number)
            localStorage.setItem("ordergoodid",total.goods_id)
          })
        })
        price=price-item.preferential_price
        localStorage.setItem("order",item.order_no )
        localStorage.setItem("orderTid",item.pintuan_tid)

        this.$router.replace({
          path:"/orderPay",
          query:{
            id:price,
            order:item.order_no,
            count:arr,
            pintuan_tid:item.pintuan_tid,
//            goodsid:goodsid
          }
        })
      },
      selectOrderList(){
        if(this.$route.query.id){
          this.active=Number(this.$route.query.id)
        }
        var obj={}
        let code=""
        let payCode=""
        switch (this.active){
          case 0:
            obj={
              user_id :localStorage.getItem("userid"),
            }
            break;
          case 1:
            obj={
              user_id :localStorage.getItem("userid"),
              pay_status :0
            }
             break;
          case 2:
            obj={
              user_id :localStorage.getItem("userid"),
              status :0,
              pay_status:1
            }
            break
        }
        this.$api.selectOrderList(obj)
          .then(res=>{
          this.list=res.data
            this.list.forEach(function (num) {
              num.preferential_price=num.preferential_price==null ? 0 : num.preferential_price
            })

          })

      },
      deleteOrder(id){//删除订单

          this.$dialog.alert({
            title: '是否取消改订单',
            message: '',
            showCancelButton:true
          }).then(() => {
            this.$api.deleteOrder({
              id:id
            })
              .then(res=>{
              if(res.status==200){
                this.selectOrderList()
                 }
              })
          });
      },

    },
   mounted(){
     this.selectOrderList()
   }
  }
</script>
<style  scoped="">
  *{
    /*overflow-x:hidden;*/
    padding: 0;
    margin: 0;
  }
  header{
    width: 100%;
    height: 50px;
    background:#ff2500 ;
    position: fixed;
    z-index: 200;
    top: 0;
  }
  header img{
    width: 18px;
    height: 18px;
    padding-left: 10px;
  }
  .headerDiv{
    display: flex;
    align-items: center;
    line-height: 50px;
  }
  .headerDiv p{
    margin: auto;
    font-size: 15px;
  }
  .shopList{
    padding-top: 70px;
  }
  .shopListDetailsImg{
    width: 80px;
    /*height: 80px;*/
  }
  .shopListDetailsImg img{
    width: 100%;
    height: 100%;
  }
  .shopListDetails{
    display: flex;
    padding: 8px 6px;
  }
  .shopRoduct{
    margin-left: 10px;
    display: flex;
    /*flex-direction: column;*/
    justify-content: space-between;
    flex: 1;
    /*width: 60%;*/
  }
  .shopPrice{
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }
  .shopPrice p{
    margin-top: 1px;
  }
  .shopListDiv{
    padding: 10px;
    border-top: solid 10px #E4E4E4;
    margin-top: 10px;
    background: #ffffff;
    border-radius: 15px;
  }
  .shopRoductM{
   padding-top: 10px;
  }
  /deep/.van-submit-bar{
    bottom: 50px;
  }
  .shopListStatus{
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .status{
   font-size: 14px;
    color: #f56723;
  }
  .delOrder{
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
  .delOrderStyle{
    border: solid 1px #ff2500;
    border-radius: 1rem;
    font-size: 12px;
    color: #ff2500;
    margin-left: 18px;
    padding: 3px 9px;
  }
  .delOrderSpan{
    border:solid 1px grey ;
    border-radius: 1rem;
    font-size: 12px;
    margin-left: 18px;
    padding: 3px 9px;
  }
  .shopIcon{
    display: flex;
    align-items: center;
    font-size: 15px;
  }
  .shopIcon span{
    margin-left: 5px;
    display: flex;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shop/allOrder.vue